import React, { Component } from 'react';

// Helper
import { apiForm, apiFetch } from '../../Helper/Api';
import { usd, egp } from './format';

// Components
import { Dialog } from 'primereact/dialog';
import { InputNumber } from 'primereact/inputnumber';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

const METHODS = ['فودافون كاش', 'إنستاباي', 'تحويل بنكي', 'أخرى'].map(m => ({ label: m, value: m }));

// "I paid, please add it to my wallet": amount, how it was paid, the transfer number and a photo of the receipt.
// The platform owner checks it and approves (the wallet is credited) or rejects it.
class TopUpDialog extends Component {
    state = { amount: null, method: METHODS[0].value, reference: '', note: '', receipt: null, sending: false, error: null,
        promo: '', promoCheck: null }

    componentDidUpdate(prev) {
        if (this.props.visible && !prev.visible) {
            this.setState({
                amount: this.props.suggestedAmount ? Math.ceil(this.props.suggestedAmount * 100) / 100 : null,
                method: METHODS[0].value, reference: '', note: '', receipt: null, sending: false, error: null,
                promo: '', promoCheck: null,
            });
        }
    }

    checkPromo = () => {
        const code = this.state.promo.trim();
        if (!code) { this.setState({ promoCheck: null }); return; }
        apiFetch('/billing/promo/topup-check', { query: { code, amountUsd: this.state.amount || 0 } })
            .then(promoCheck => this.setState({ promoCheck }))
            .catch(e => this.setState({ promoCheck: { valid: false, message: e.message } }));
    }

    send = () => {
        const { amount, method, reference, note, receipt, promo } = this.state;
        if (!amount || amount <= 0) { this.setState({ error: 'اكتب المبلغ اللي حوّلته' }); return; }
        if (!reference.trim() && !receipt) { this.setState({ error: 'اكتب رقم العملية أو ارفع صورة الإيصال' }); return; }
        const form = new FormData();
        form.append('amountUsd', String(amount));
        form.append('method', method);
        if (reference.trim()) form.append('reference', reference.trim());
        if (note.trim()) form.append('note', note.trim());
        if (receipt) form.append('receipt', receipt);
        if (promo.trim()) form.append('promoCode', promo.trim());
        this.setState({ sending: true, error: null });
        apiForm('/billing/topups', form)
            .then(row => { this.setState({ sending: false }); this.props.onSent(row); })
            .catch(e => this.setState({ sending: false, error: e.message }));
    }

    render() {
        const { visible, onHide, rate, supportWhatsapp } = this.props;
        const { amount, method, reference, note, receipt, sending, error, promo, promoCheck } = this.state;
        const footer = (
            <div>
                <Button label="إلغاء" className="p-button-text" onClick={onHide} disabled={sending} />
                <Button label={sending ? 'جاري الإرسال...' : 'إرسال طلب الشحن'} icon="pi pi-send" onClick={this.send} disabled={sending} />
            </div>
        );
        return (
            <Dialog header="شحن المحفظة" visible={visible} onHide={onHide} footer={footer} className="billing-dialog" dismissableMask>
                <p className="b-hint">
                    حوّل المبلغ لحساب المنصة، وبعدين املأ البيانات دي وارفع صورة الإيصال. الرصيد هيتضاف لمحفظتك بعد مراجعة الإدارة.
                    {supportWhatsapp && <> لبيانات التحويل كلّم الدعم على <a href={`https://wa.me/${supportWhatsapp}`} target="_blank" rel="noopener noreferrer">واتس اب</a>.</>}
                </p>
                <div className="b-field">
                    <label htmlFor="topup-amount">المبلغ بالدولار</label>
                    <InputNumber inputId="topup-amount" value={amount}
                        onValueChange={e => this.setState({ amount: e.value }, () => { if (this.state.promoCheck) this.checkPromo(); })}
                        mode="decimal" minFractionDigits={0} maxFractionDigits={2} min={0} suffix=" $" />
                    {amount > 0 && rate && <small className="b-muted">يعادل {egp(amount * rate)} — حوّل المبلغ بالجنيه بالقيمة دي</small>}
                </div>
                <div className="b-field">
                    <label htmlFor="topup-method">طريقة الدفع</label>
                    <Dropdown inputId="topup-method" value={method} options={METHODS} onChange={e => this.setState({ method: e.value })} />
                </div>
                <div className="b-field">
                    <label htmlFor="topup-ref">رقم العملية</label>
                    <InputText id="topup-ref" value={reference} dir="ltr" maxLength={200} onChange={e => this.setState({ reference: e.target.value })} />
                </div>
                <div className="b-field">
                    <label htmlFor="topup-receipt">صورة الإيصال (صورة أو PDF، حتى 10 ميجا)</label>
                    <input id="topup-receipt" type="file" accept="image/*,application/pdf"
                        onChange={e => this.setState({ receipt: e.target.files && e.target.files[0] ? e.target.files[0] : null })} />
                    {receipt && <small className="b-muted">{receipt.name}</small>}
                </div>
                <div className="b-field">
                    <label htmlFor="topup-note">ملاحظة (اختياري)</label>
                    <InputText id="topup-note" value={note} maxLength={500} onChange={e => this.setState({ note: e.target.value })} />
                </div>
                <div className="b-field">
                    <label htmlFor="topup-promo">كود هدية (اختياري)</label>
                    <div className="p-inputgroup">
                        <InputText id="topup-promo" value={promo} dir="ltr" maxLength={50}
                            onChange={e => this.setState({ promo: e.target.value.toUpperCase(), promoCheck: null })} />
                        <Button label="تحقق" className="p-button-outlined" onClick={this.checkPromo} disabled={!promo.trim()} />
                    </div>
                    {promoCheck && !promoCheck.valid && <small className="b-error">{promoCheck.message}</small>}
                    {promoCheck && promoCheck.valid && <small className="b-ok">هدية {usd(promoCheck.bonusUsd)} هتتضاف مع الشحن</small>}
                </div>
                {error && <p className="b-error" role="alert">{error}</p>}
                {amount > 0 && <p className="b-muted">هيتضاف لمحفظتك {usd(amount + (promoCheck && promoCheck.valid ? Number(promoCheck.bonusUsd) : 0))} بعد الموافقة.</p>}
            </Dialog>
        );
    }
}

export default TopUpDialog;
